import { createFileRoute } from "@tanstack/react-router";
import { PriorityRulesScreen } from "../components/relations/PriorityRulesScreen";

export const Route = createFileRoute("/_auth/relations/priority")({
  staticData: {
    titleKey: "relations.priority.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 7,
  },
  component: PriorityRulesScreen,
});
